import { Button, Stack } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React, { useContext, useEffect, useState } from 'react';
import FileReportSummaryTrigger from './FileReportSummaryTrigger';
import FileReportsSummary from './FileReportsSummary/FileReportsSummary';
import { visitOperations } from '../variables/visitOperations';
import PatientInfoStack from 'Routes/Protected/CurrentPatients/Components/EachPatient/component/PatientInfoStack';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import PatientImageTrigger from './PatientImage/PatientImageTrigger';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useNavigate } from 'react-router-dom';
import { hwndjs } from 'utils/hwnd';
import useGetSummaryList from './FileReportsSummary/hooks/useGetSummaryList';

const PatienCardActions = ({ Patient }) => {
  const navigate = useNavigate();
  const documentSummaryList = useGetSummaryList();

  const patientImage_label = FindLangKey(
    'main-menu-button-pacs-images'
  );
  const GlobalConstants = useContext(GlobalContext);

  const [openSummaryInput, setOpenSummaryInput] =
    useState();

  const [
    openMedicalImageDialog,
    setOpenMedicalImageDialog,
  ] = useState(false);

  const visitOperation = visitOperations(Patient);
  useEffect(()=>{
    if(openMedicalImageDialog){
      navigate({
        pathname: `/pacsImages`,
        search: `${hwndjs(Patient?.IdPatient)}`,
      });
    }

  },[openMedicalImageDialog])


  // console.log('openSummaryInput--->',Patient)

  return (
    <React.Fragment>
      <Stack mt="1em" gap="1em">
        <Stack>
          <FileReportSummaryTrigger
            setOpenSummaryInput={setOpenSummaryInput}
            documentSummaryList={documentSummaryList}
          />
          {openSummaryInput ? (
            <FileReportsSummary Patient={Patient} documentSummaryList={documentSummaryList}/>
          ) : (
            <></>
          )}
        </Stack>

        <Stack>
          <PatientImageTrigger
            setOpenMedicalImageDialog={
              setOpenMedicalImageDialog
            }
          />

          {/* {openMedicalImageDialog ? (
            <Stack gap=".5em">
              <Button
                variant="contained"
                sx={{
                  color: `${themeColors.ColorPrimary} !important`,
                }}
                onClick={() => {
                  navigate({
                    pathname: `/pacsImages`,
                    search: `${hwndjs(Patient?.FldId)}`,
                  });
                }}
              >
                {patientImage_label}
              </Button>
        
            </Stack>
          ) : (
            <></>
          )} */}
        </Stack>

        {visitOperation?.map(
          (element) =>
            !element?.disabled && (
              <PatientInfoStack
                ImageSource={element?.image}
                paragraph={element?.title}
                key={GlobalConstants.uuidV4()}
                clickable={true}
                navigate={GlobalConstants.navigate}
                path={element.path}
                Patient={Patient}
                func={element?.func}
              />
            )
        )}
      </Stack>
    </React.Fragment>
  );
};

export default PatienCardActions;
